import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './style/cm1.css';
import './style/hm1.css';
import './style/hm2.css';
import './style/bk1.css';
import './style/bk2.css';
import './style/cu1.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
reportWebVitals();
